<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col :cols="8">
                    <h1 class="headline font-weight-light mb-3">ON CLAIM</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="11" sm="5" md="3">
                    <v-autocomplete
                        :items="data_supplier"
                        item-text="supplier_name"
                        item-value="supplier_id"
                        menu-props="auto"
                        v-model="form_search.supplier_id"
                        label="Select Supplier"
                        hide-details
                        @change="change_supplier()"
                    ></v-autocomplete>
                </v-col>
                <v-col
                    cols="11"
                    sm="5"
                    md="3"
                    v-if="form_search.supplier_id != ''"
                >
                    <v-autocomplete
                        :items="data_partno"
                        item-text="part_name"
                        item-value="part_id"
                        menu-props="auto"
                        v-model="form_search.part_id"
                        label="Select Part"
                        hide-details
                        @change="change_part()"
                    ></v-autocomplete
                ></v-col>
                <v-col cols="1" class="mt-4">
                    <v-btn
                        x-small
                        fab
                        class="mr-1"
                        v-if="
                            form_search.supplier_id != '' ||
                                form_search.part_id != ''
                        "
                        @click="reset()"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col>
            </v-row>
            <v-card class="mt-5">
                <div v-for="(row, index) in data_claim" :key="index">
                    <hr v-if="index != 0" class="ml-1 mr-1" />
                    <hr v-if="index != 0" class="ml-1 mr-1" />

                    <v-row class="pa-5">
                        <v-col cols="12" sm="6" md="4"
                            ><b>Supplier :</b> {{ row.supplier_name }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"
                            ><b>Packinglist :</b>
                            {{ row.claim_packinglist_no }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4" class="text-right">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        fab
                                        small
                                        :color="
                                            chk_export_data == false
                                                ? 'green accent-3'
                                                : ''
                                        "
                                        :disabled="chk_export_data == true"
                                        class="mr-1"
                                        @click="
                                            export_data(
                                                row.claim_packinglist_no
                                            )
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon
                                            v-if="chk_export_data == false"
                                            color="teal darken-4"
                                            >mdi-file-excel</v-icon
                                        >
                                        <img
                                            v-if="chk_export_data == true"
                                            src="../../assets/all/Loading.gif"
                                            style="width:6%; "
                                        />
                                    </v-btn>
                                </template>
                                <span>Export Data</span>
                            </v-tooltip>
                        </v-col>
                        <v-col cols="12" sm="6" md="4"
                            ><b>Claim Date :</b> {{ row.claim_date }}</v-col
                        >
                        <v-col cols="12" sm="6" md="4"
                            ><b>Claim By :</b> {{ row.claim_name }}</v-col
                        >
                    </v-row>

                    <v-row class="mar-t-20">
                        <v-col cols="12">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">#</th>
                                            <th class="text-center">
                                                Part No
                                            </th>
                                            <th class="text-center">
                                                Part Description
                                            </th>
                                            <th class="text-center">
                                                Singlepart
                                            </th>
                                            <th class="text-center">
                                                Issue SN
                                            </th>
                                            <th class="text-center">
                                                Defective Type
                                            </th>
                                            <th class="text-center">
                                                Defective SN
                                            </th>
                                            <th class="text-center">Receive</th>
                                            <th class="text-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(data_tr,
                                            num) in row.onclaim_part"
                                            :key="num"
                                        >
                                            <td class="text-center">
                                                {{ num + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.part_name }}
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.part_description }}
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.singlepart }}
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.issue_sn }}
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.defective_type }}
                                            </td>
                                            <td class="text-center">
                                                {{ data_tr.defective_sn }}
                                            </td>

                                            <td class="text-center">
                                                <v-row>
                                                    <v-col
                                                        cols="9"
                                                        class="text-right"
                                                    >
                                                        <v-text-field
                                                            dense
                                                            label="Serial"
                                                            v-model="
                                                                form[
                                                                    data_tr
                                                                        .defective_id
                                                                ]
                                                            "
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col cols="1">
                                                        <v-btn
                                                            :disabled="
                                                                form[
                                                                    data_tr
                                                                        .defective_id
                                                                ] == null ||
                                                                    form[
                                                                        data_tr
                                                                            .defective_id
                                                                    ] == ''
                                                            "
                                                            color="success"
                                                            fab
                                                            x-small
                                                            @click="
                                                                save_receive(
                                                                    data_tr.defective_id
                                                                )
                                                            "
                                                        >
                                                            <v-icon
                                                                >mdi-content-save</v-icon
                                                            >
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td>
                                                <v-btn
                                                    color="yellow"
                                                    rounded
                                                    small
                                                    :disabled="
                                                        form[
                                                            data_tr.defective_id
                                                        ] != '' &&
                                                            form[
                                                                data_tr
                                                                    .defective_id
                                                            ] != null
                                                    "
                                                    @click="
                                                        scrap(
                                                            data_tr.defective_id
                                                        )
                                                    "
                                                    >Scrap</v-btn
                                                >
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <div>
                            <v-btn class="mx-2" fab small @click="back()">
                                <v-icon dark>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn
                                class="mx-2"
                                fab
                                small
                                :color="btn_color(n)"
                                v-for="n in page_count"
                                :key="n"
                                @click="get_claim_page(page_num_show(n))"
                            >
                                {{ page_num_show(n) }}
                            </v-btn>

                            <v-btn class="mx-2" fab small @click="next()">
                                <v-icon dark>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">RETURN PART</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete
                                    :items="defective_part_no"
                                    label="Select Part No"
                                    item-text="part_name"
                                    item-value="part_id"
                                    menu-props="auto"
                                    v-model="form.part_id"
                                    required
                                    hide-details
                                ></v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    label="Serial"
                                    v-model="form.serial"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="" rounded small @click="close">Cancel</v-btn>
                    <v-btn
                        color="success darken-1"
                        rounded
                        small
                        @click="save_receive()"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.get_data()
        this.get_data_supplier()
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let { data } = await axios.get(
                url +
                    "onclaim?supplier_id=" +
                    this.form_search.supplier_id +
                    "&part_id=" +
                    this.form_search.part_id
            )
            this.data_main = data
            this.data_claim = data.data
            this.page_total = data.last_page
            this.page_total < 7
                ? (this.page_count = this.page_total)
                : (this.page_count = 7)
            // console.log(this.data_claim)
        },
        async back() {
            let url = this.data_main.prev_page_url
            let { data } = await axios.get(url)
            this.data_claim = data.data
            this.data_main = data
        },
        async get_claim_page(num) {
            this.current_page = num
            if (num != "...") {
                let url_page = url + "?page=" + num
                let { data } = await axios.get(url_page)
                this.data_claim = data.data
                this.data_main = data
            }
        },
        btn_color(n) {
            if (this.page_count == 7) {
                if (this.data_main.current_page <= 4) {
                    return this.data_main.current_page === n ? "primary" : ""
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    return n === 7 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    return n === 6 ? "primary" : ""
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    return n === 5 ? "primary" : ""
                } else {
                    return n === 4 ? "primary" : ""
                }
            } else {
                return this.data_main.current_page === n ? "primary" : ""
            }
        },
        page_num_show(n) {
            let page = n
            if (this.page_count == 7) {
                let chk2 = 0
                let chk3 = 0
                let chk4 = 0
                let chk5 = 0
                let chk6 = 0
                if (this.data_main.current_page == 1) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page == this.data_main.last_page
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 2) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 1
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else if (this.data_main.current_page == 3) {
                    chk2 = 2
                    chk3 = 3
                    chk4 = 4
                    chk5 = "..."
                    chk6 = this.data_main.last_page - 1
                } else if (
                    this.data_main.current_page ==
                    this.data_main.last_page - 2
                ) {
                    chk2 = 2
                    chk3 = "..."
                    chk4 = this.data_main.last_page - 3
                    chk5 = this.data_main.last_page - 2
                    chk6 = this.data_main.last_page - 1
                } else {
                    chk2 = "..."
                    chk3 = this.data_main.current_page - 1
                    chk4 = this.data_main.current_page
                    chk5 = this.data_main.current_page + 1
                    chk6 = "..."
                }

                n === 1 ? (page = 1) : ""
                n === 2 ? (page = chk2) : ""
                n === 3 ? (page = chk3) : ""
                n === 4 ? (page = chk4) : ""
                n === 5 ? (page = chk5) : ""
                n === 6 ? (page = chk6) : ""
                n === 7 ? (page = this.data_main.last_page) : ""
            } else {
                n === 1 ? (page = 1) : ""
                n === 2 ? (page = 2) : ""
                n === 3 ? (page = 3) : ""
                n === 4 ? (page = 4) : ""
                n === 5 ? (page = 5) : ""
                n === 6 ? (page = 6) : ""
            }
            return page
        },
        async get_data_supplier() {
            let { data } = await axios.get(url + "supplier-has-onclaim")
            this.data_supplier = data
        },
        async change_supplier() {
            let { data } = await axios.get(
                url + "get-partno-onclaim/" + this.form_search.supplier_id
            )
            this.data_partno = data
            this.get_data()
        },
        reset() {
            this.form_search.supplier_id = ""
            this.form_search.part_id = ""
            this.get_data()
        },
        // async receive(defective_part_id, defective_id) {
        //     // this.dialog = true
        //     await axios
        //         .get(url + "get-partno-list/" + defective_part_id)
        //         .then((response) => {
        //             this.form.part_id = response.data[0].part_id
        //             this.form.defective_id = defective_id
        //             this.defective_part_no = response.data
        //         })
        //         .catch((error) => {
        //             this.chk_data = true
        //         })
        // },
        close() {
            this.form.part_id = ""
            this.form.defective_id = ""
            this.dialog = false
        },
        async save_receive(defective_id) {
            let send = {
                defective_id: defective_id,
                serial: this.form[defective_id],
            }
            await axios
                .post(url + "onclaim-receive", send, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                    },
                })
                .then((response) => {
                    this.get_data()
                    this.mutatesnackbar()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                    // this.close()
                })
                .catch((error) => {
                    this.chk_data = true
                })
        },
        scrap(defective_id) {
            let defective = {
                defective_id: defective_id,
            }
            this.$swal({
                title: "Are you sure you want to scrap ?",
                text: "",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    axios
                        .post(url + "scrap", defective, {
                            headers: {
                                Authorization: "Bearer " + localStorage.token,
                            },
                        })
                        .then((response) => {
                            this.get_data()
                            this.mutatesnackbar()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            this.chk_data = true
                        })
                } else {
                    // console.log("--no")
                }
            })
        },
        async export_data(claim_packinglist_no) {
            this.chk_export_data = true
            await axios({
                url: url + "onclaim-export/" + claim_packinglist_no,
                method: "GET",
                responseType: "blob",
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
    },
    data() {
        return {
            page_count: 0,
            data_main: [],
            data_claim: [],
            data_supplier: [],
            data_partno: [],
            form_search: {
                supplier_id: "",
                part_id: "",
            },
            form: {},
            text: "Success, Your work has been saved",
            dialog: false,
            defective_part_no: [],
            defective_id: "",
            chk_export_data: false,
        }
    },
}
</script>
